import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const getPublicBundle = gql`
  query GetPublicBundle($input: GetBundle!) {
    getPublicBundle(input: $input) {
      ...PublicBundle
    }
  }

  ${Fragments.bundle.publicBundle}
`;
